import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface Offering {
  id: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  category: string;
  is_active: number;
}

export default function Catalog() {
  const [offerings, setOfferings] = useState<Offering[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    name: '',
    description: '',
    price: '',
    currency: 'USD',
    category: 'service',
  });

  useEffect(() => {
    loadOfferings();
  }, []);

  async function loadOfferings() {
    try {
      setLoading(true);
      const res = await api.get('/api/offerings');
      setOfferings(res.data || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await api.post('/api/offerings', {
        ...form,
        price: parseFloat(form.price),
      });
      setForm({ name: '', description: '', price: '', currency: 'USD', category: 'service' });
      loadOfferings();
    } catch (err: any) {
      setError(err.message);
    }
  }

  return (
    <div>
      <h1 style={styles.heading}>Catalog</h1>
      {error && <div style={styles.error}>{error}</div>}

      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          placeholder="Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          style={styles.input}
          required
        />
        <input
          placeholder="Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          style={styles.input}
        />
        <input
          placeholder="Price"
          type="number"
          step="0.01"
          value={form.price}
          onChange={(e) => setForm({ ...form, price: e.target.value })}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button}>Add Offering</button>
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Category</th>
              <th style={styles.th}>Description</th>
              <th style={styles.th}>Price</th>
              <th style={styles.th}>Active</th>
            </tr>
          </thead>
          <tbody>
            {offerings.map((o) => (
              <tr key={o.id}>
                <td style={styles.td}>{o.name}</td>
                <td style={styles.td}>{o.category}</td>
                <td style={styles.td}>{o.description}</td>
                <td style={styles.td}>{o.currency} {o.price.toFixed(2)}</td>
                <td style={styles.td}>{o.is_active ? 'Yes' : 'No'}</td>
              </tr>
            ))}
            {offerings.length === 0 && (
              <tr>
                <td colSpan={5} style={{ ...styles.td, textAlign: 'center', color: '#9ca3af' }}>
                  No offerings yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  heading: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  error: { background: '#fef2f2', color: '#991b1b', padding: 10, borderRadius: 8, marginBottom: 12 },
  form: { display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' },
  input: { padding: '8px 10px', fontSize: 14, border: '1px solid #e5e7eb', borderRadius: 6, minWidth: 140 },
  button: { padding: '8px 16px', fontSize: 14, background: '#111827', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#6b7280' },
  td: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6' },
};
